import browserUpdate from 'browser-update'

browserUpdate({
    required: {
        e: 79, // Edge
        f: -3, // Firefox
        o: -3, // Opera
        s: 10.1, // Safari
        c: -5, // Chrome
        samsung: 7.0,
        vivaldi: 1.2
    },
    insecure: true,
    test: false,
    no_permanent_hide: true,
    noclose: true
})
